class GeoCode {
  latitude: number;
  longitude: number;

  constructor(latitude: number, longitude: number) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
}

export class Branch {
  id: string;
  name: string;
  address: string;
  location: GeoCode;
  store_code: string;

  constructor(id: string, name: string, address: string, location: any, store_code: string) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.location = new GeoCode(location.latitude, location.longitude);
    this.store_code = store_code;
  }
}

class Customer {
  name: string;
  mobile_no: string;

  constructor(args: any) {
    this.name = args.name;
    this.mobile_no = args.mobile_no;
  }
}

class Flow {
  type: string;
  code: string;

  constructor(args: any) {
    this.type = args.type;
    this.code = args.code;
  }
}

export class Hub {
  name: string;

  constructor(hub: any) {
    this.name = hub.name;
  }
}

export class History {
  status: string;
  location: GeoCode;
  timestamp: Date;

  constructor(status: string, timestamp: Date, location: any = undefined) {
    this.status = status;
    this.timestamp = new Date(timestamp);
    this.location = location && new GeoCode(location.latitude, location.longitude);
  }
}

export class Order {
  id: string;
  trip_id: string;
  order_no: string;
  status: string;
  instructions: string;
  alcohol: boolean;
  assignable: boolean;
  branch: Branch;
  customer: Customer;
  address: string;
  location: GeoCode;
  collection_time: Date;
  delivery_time: Date;
  origination: string;
  payment_type: string;
  delivery_price: number;
  abandon_flow: Flow;
  delivery_flow: Flow;
  created_at: Date;
  hub: Hub;

  constructor(args: any) {
    this.id = args.id;
    this.trip_id = args.trip_id;
    this.order_no = args.order_no;
    this.status = args.status;
    this.alcohol = args.alcohol;
    this.instructions = args.instructions;
    this.assignable = args.assignable;
    this.branch = new Branch(
      args.branch.id,
      args.branch.name,
      args.branch.address,
      args.branch.location,
      args.branch.store_code
    );
    this.customer = new Customer(args.customer);
    this.address = args.address;
    this.location = new GeoCode(args.location.latitude, args.location.longitude);
    this.collection_time = args.collection_time;
    this.delivery_time = args.delivery_time;
    this.delivery_price = args.delivery_price;
    this.payment_type = args.payment_type;
    this.origination = args.origination;
    this.delivery_flow = args.delivery_flow && new Flow(args.delivery_flow);
    this.abandon_flow = args.abandon_flow && new Flow(args.abandon_flow);
    this.created_at = args.created_at;
    this.hub = new Hub(args.hub);
  }
}
